<template>
<div :id="'CookiesDialog_' + DialogIndex" class="CookiesDialogdBody">
  <DialogDisabler v-if="Saving"></DialogDisabler>
  <div class="M-Auto DialogContainer">
    <div class="DialogBody D-Flex">
      <div class="CookiesRow F-C2">
        <CookiesIcon class="M-Auto Shadow0 P1em" style="width: 4em; height: 4em;" :ID="'Compensate'"></CookiesIcon>
        <div class="CookiesRow W-100">
          <span class=" M-Auto color3">{{LanguageSelector('Are you sure you want to pay salaries now', 'هل انت متأكد من انك تريد انزال الرواتب الان')}}</span>
        </div>
        <div class="W-100" style="height:20px;"></div>
        <div class="M-Auto F-Bold">
          <button @click="$store.commit('CloseDialog', DialogIndex)" :style="'background: ' + Theme.Shade3" class="F-Bold CookiesButton DialogFooterButton">{{LanguageSelector('Cancel', 'الغاء')}}</button>
          <button @click="PaySalaries()" class="F-Bold CookiesButton DialogFooterButton BGThird">{{LanguageSelector('Confirm', 'تأكيد')}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data () {
    return {
      Saving: false
    }
  },
  props: {
    DialogIndex: Number,
    DialogData: { default: '' }
  },
  mounted () {
    try {
      var DialogPos = document.getElementById('CookiesDialog_' + this.DialogIndex).offsetTop - 60
      window.scrollTo(0, DialogPos)
    } catch (error) {
      console.log('error: ', error.message)
    }
  },
  methods: {
    PaySalaries () {
      this.Saving = true
      this.Post('POST', 'Financial/SaleryInstall', {}).then(response => {
        this.Saving = false
        this.CloseDialog(this.DialogIndex)
      }, error => {
        this.Saving = false
        this.OpenDialog('Error_Dialog', 'Error', error) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
      })
    }
  }
}
</script>
<style scoped>
.DialogBody{
  width: 600px;
  max-width: 65vw;
}
.DialogContainer{
  padding: 50px;
}
@media (max-width: 500px) {
  .FlexBreaker{
    flex-direction: column;
  }
  .FlexBreaker > *{
    width: 80% !important;
  }
  .DialogContainer{
    padding: 1em;
  }
  .CookiesDialogdBody{
    font-size: 3vw;
  }
}
@media (max-width: 300px) {
  .CookiesDialogdBody{
    font-size: 4vw;
  }
}
.CookiesDialogdBody{
  margin-bottom: 0px;
}
</style>
